const Tab = new function () {

    const tabsContainerClass = '.na-tabs-container';
    const tabLinkAttr = '[data-tab]';
    const tabContentAttr = '[data-tab-content]';
    const activeClass = 'is-active';
  
    this.init = () => {
      const allTabLinks = document.querySelectorAll(tabLinkAttr);
      allTabLinks.forEach(tabLink => tabLink.addEventListener('click', () => this.handleTabClick(tabLink)));
    };
  
    this.activeFirstTab = (tabsContainer) => {
      const tab = tabsContainer.querySelector(tabLinkAttr);
      this.handleTabClick(tab);
    }
  
    this.handleTabClick = (clickedTab) => {
      const targetTab = clickedTab.dataset.tab;
      const parentTabsContainer = findParentTabsContainer(clickedTab);
  
    //   // Deactivate all tab links within the same level
      const tabLinks = parentTabsContainer.querySelectorAll(tabLinkAttr);
      tabLinks.forEach(link => {
        link.classList.remove(activeClass);
        link.setAttribute('aria-selected', 'false');
      });
  
      // Activate the clicked tab
      clickedTab.classList.add(activeClass);
      clickedTab.setAttribute('aria-selected', 'true');
  
      // Show the corresponding tab content
      this.showTabContent(targetTab, parentTabsContainer);
    };
  
    this.showTabContent = (tabId, tabsContainer) => {    
      const allTabContents = tabsContainer.querySelectorAll(tabContentAttr);
      let allChildTabs = [];
  
      allTabContents.forEach(content => {
        content.classList.remove(activeClass);
        content.setAttribute('aria-hidden', 'true');
  
        if (content.dataset.tabContent === tabId) {
          content.classList.add(activeClass);
          content.setAttribute('aria-hidden', 'false');
          
          // If has children tabs, store for active later
        //   const childTabs = content.querySelector(tabsContainerClass);
        //   if (childTabs) allChildTabs.push(childTabs);
        }
      });
  
      // Active first from children tabs
    //   allChildTabs.forEach(childTabs => this.activeFirstTab(childTabs));
    };
  
    const findParentTabsContainer = (element) => {
      const parent = element.parentElement;
      if (!parent) return null;
  
      if (parent.classList.contains('na-tabs-container')) {
        return parent;
      } else {
        return findParentTabsContainer(parent);
      }
    };
  
    this.update = () => {
      const allTabLinks = document.querySelectorAll(tabLinkAttr);
      allTabLinks.forEach(tabLink => tabLink.addEventListener('click', () => this.handleTabClick(tabLink)));
    }
  };
  
  export default Tab;